import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-purchase-orders",
  "use": "ico-purchase-orders-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"ico-purchase-orders\">\n    <path d=\"M 4 3 L 4 14 L 6 14 L 6 5 L 19 5 L 19 18 C 19 18.56503 18.56503 19 18 19 C 17.448 19 17 18.551 17 18 L 17 16 L 2 16 L 2 18 C 2 19.654 3.346 21 5 21 L 18 21 C 19.64497 21 21 19.64497 21 18 L 21 3 L 4 3 z M 8 8 L 8 10 L 10 10 L 10 8 L 8 8 z M 12 8 L 12 10 L 17 10 L 17 8 L 12 8 z M 8 12 L 8 14 L 10 14 L 10 12 L 8 12 z M 12 12 L 12 14 L 17 14 L 17 12 L 12 12 z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol